import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import Youtube from "react-youtube";

import magazine from "modules/magazine";
import Popup from "components/Popup/Popup";
import dataFormatter from "utils/dataFormatter";
import "./Magazine.css";

class Magazine extends Component {
  constructor(props) {
    super(props);
    props.getMagazine();
    this.state = {
      isPopupActive: false,
      videoId: null,
      magazineWidth: null
    };
  }

  render() {
    return (
      <div>
        {this.state.isPopupActive ? (
          <Popup onOverlayClick={() => this.closeYoutubePopup()}>
            <Youtube
              videoId={this.state.videoId}
              opts={{
                width: "100%",
                height: "100%",
                playerVars: {
                  autoplay: 1
                }
              }}
            />
          </Popup>
        ) : (
          ""
        )}
        {this.props.magazine.length ? <div className="magazine">
          {dataFormatter(this.props.magazine).map((row, index) => {
            return (
              <div
                key={index}
                className="row"
                style={{
                  gridTemplateColumns: `${this.rowElementStyling(row)}`
                }}
              >
                {row.map((col, index) => {
                  if (col.url.search(/youtube/) !== -1) {
                    return (
                      <div key={index} className="cell">
                        <button
                          className="shadow card-link"
                          onClick={() => this.openYoutubePopup(col.content)}
                        />
                        <div className={`height-${col.style.height_style}`}>
                          <div
                            className="image"
                            style={{
                              background: `url(${process.env.REACT_APP_IMG_SERVER}/img/${
                                col.image_id
                              }/mobile) no-repeat center`,
                              backgroundSize: "cover"
                            }}
                          />
                        </div>
                        <div
                          className="card-info-over"
                          onClick={() => this.openYoutubePopup(col.content)}
                        >
                          <div> {col.title} </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div key={index} className="cell">
                        {col.style.height_style === 1 ? (
                          <Link
                            className="category-link-over"
                            to={{ pathname: `/articles/${col.rubric_url}` }}
                          >
                            {" "}
                            {col.rubric
                              ? col.rubric[0].toUpperCase() +
                                col.rubric.slice(1)
                              : ""}{" "}
                          </Link>
                        ) : (
                          ""
                        )}
                        <a
                          className={
                            col.style.height_style === 1
                              ? "shadow card-link"
                              : "card-link"
                          }
                          href={col.url}
                        >
                          {col.url}
                        </a>
                        <div className={`height-${col.style.height_style}`}>
                          <div
                            className="image"
                            style={{
                              background: `url(${process.env.REACT_APP_IMG_SERVER}/img/${
                                col.image_id
                              }/mobile) no-repeat center`,
                              backgroundSize: "cover"
                            }}
                          />
                        </div>
                        {col.style.height_style === 1 ? (
                          <a className="card-info-over" href={col.url}>
                            <div> {col.title} </div>
                            <div> {col.content} </div>
                          </a>
                        ) : (
                          <div className="card-info-under">
                            <div>
                              <Link
                                className="category-link-under"
                                to={{ pathname: `/articles/${col.rubric_url}` }}
                              >
                                {" "}
                                {col.rubric
                                  ? col.rubric[0].toUpperCase() +
                                    col.rubric.slice(1)
                                  : ""}{" "}
                              </Link>
                            </div>
                            <div> {col.content} </div>
                          </div>
                        )}
                      </div>
                    );
                  }
                })}
              </div>
            );
          })}
        </div> : null}
      </div>
    );
  }

  componentDidMount() {
    window.addEventListener("resize", this.onMagazineResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onMagazineResize);
  }

  openYoutubePopup = videoId => {
    this.setState({
      isPopupActive: true,
      videoId
    });
  };

  closeYoutubePopup = () => {
    this.setState({
      isPopupActive: false,
      videoId: null
    });
  };

  onMagazineResize = () => {
    this.setState({
      magazineWidth:
        document.querySelector(".magazine").clientWidth / 2 - 40 / 2
    });
  };

  rowElementStyling = row => {
    let magazine = this.state.magazineWidth
      ? this.state.magazineWidth
      : document.querySelector(".magazine").clientWidth / 2 - 40 / 2;
    let fraction;

    return row
      .sort((a, b) => a.position.position - b.position.position)
      .map(item => {
        if (row.length === 3) {
          fraction =
            item.position.length === 2
              ? magazine + "px"
              : item.position.length + "fr";
          return fraction;
        } else {
          fraction = item.position.length + "fr";
          return fraction;
        }
      })
      .toString()
      .replace(/,/g, " ");
  };
}

const mapStateToProps = state => ({
  magazine: state.magazine.data
});

const mapDispatchToProps = dispatch => ({
  getMagazine: bindActionCreators(magazine.actions.getMagazine, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Magazine);



// WEBPACK FOOTER //
// ./src/components/Magazine/Magazine.js